import resizable from './resizable'
import loadable from './loadable'
import filterDays from './filter-days'
import filterDates from './filter-dates'

/**
 * Create a mixin array
 *
 * @param {string[]} names  Variadic list of mixin names
 *
 * @returns {Array}
 */
export function mixin (...names) {
  const mixins = []
  const lookup = {
    'loadable': loadable,
    'resizable': resizable,
    'filter-days': filterDays,
    'filter-dates': filterDates
  }

  names.forEach(key => {
    if (key in lookup) {
      mixins.push(lookup[key])
    } else {
      throw new Error(`Unknown mixin type ${key}. Must be one of ${Object.keys(lookup).join(', ')}`)
    }
  })

  return mixins
}

/**
 * Create a base card object with optional mixins
 *
 * @param {string[]} names  Variadic list of mixin names

 * @returns {{mixins: Array, components: Object, data: Function, computed: Object, created: Function, methods: Object}}
 */
export function card (...names) {
  return {...loadable, mixins: mixin(...names)}
}

export default mixin

export {
  resizable,
  loadable,
  filterDays,
  filterDates
}

